import { createAction } from '@lingoda/core';

export const resetCurriculumBookingFilter = createAction('booking/RESET_CURRICULUM_BOOKING_FILTER');
